import React from 'react'
import Typography from '@mui/material/Typography'
import { twMerge } from 'tailwind-merge'

import styles from '../../ExplorePage.module.scss'

type PageTitleProps = {
  className?: string
  subtitle?: string
  title?: string
}

const PageTitle: React.FC<PageTitleProps> = props => {
  const { className, subtitle, title } = props
  return (
    <div className={twMerge('pr-6', styles.PageTitleContainer, className)}>
      <Typography variant="h4" className="mb-2">
        {title}
      </Typography>

      <Typography className="text-white-med-on-dark" variant="body1">
        {subtitle}
      </Typography>
    </div>
  )
}

export default PageTitle
